export default "__VITE_ASSET__81gLNod3__"